import { render } from "./ProfileView.vue?vue&type=template&id=7b990dfe&scoped=true&ts=true"
import script from "./index.ts?vue&type=script&lang=ts"
export * from "./index.ts?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=7b990dfe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b990dfe"]])

export default __exports__